import { styled } from '@grupoboticario/flora-react';
import { Link } from 'react-router';

export const ProductListCardStyles = {
  LinkProductDetail: styled(Link, {
    color: '$dark-light',
    textDecoration: 'none',
    display: 'inline-block',
    width: '100%',
  }),
};
